module.exports = __webpack_public_path__ + "img/代表队已报名.06a89003.png";